import React from 'react';
import logo from '../../assets/logo.png';
import { useWallet } from '../../context/WalletContext';
import { 
  FaSignOutAlt,

  FaCoins,
  FaUser,
  FaChartPie,
  FaWallet,
  FaBook,
  FaHistory,
  FaHammer,
  FaHeadset,
  FaCalculator,
  FaTimes,
  FaGift,
  FaChevronRight
} from 'react-icons/fa';
import { 
  HiOutlineViewGrid, 
  HiOutlineDocumentText
} from 'react-icons/hi';

const MobileDrawer = ({ isOpen, onClose, activeTab, setActiveTab }) => {


  const { isAdmin, disconnectWallet } = useWallet();
  // Ensure Overview is always the first and visible
  const mainNavItems = [
    { id: 'overview', icon: <HiOutlineViewGrid size={20} />, label: 'Overview', alwaysShow: true },
    { id: 'mine', icon: <FaHammer size={18} />, label: 'Mine' },
    { id: 'claim', icon: <FaGift size={18} />, label: 'Claim' },
    { id: 'wallet', icon: <FaWallet size={18} />, label: 'Wallet' },
    { id: 'referral', icon: <FaUser size={18} />, label: 'Referral' },
    { id: 'levels', icon: <FaBook size={18} />, label: 'Packages' },
    { id: 'user-analytics', icon: <FaCalculator size={18} />, label: 'User Analytics' },
    { id: 'history', icon: <FaHistory size={18} />, label: 'History' },
  ];

  // Use React Router navigation if available for tab routes
  const handleNavigation = (tabId) => {
    // If React Router navigation is available, use it for main tabs
    if (typeof window !== 'undefined' && window.location && tabId === 'claim') {
      // Try to use history API for smoother navigation
      if (window.location.pathname !== '/dashboard') {
        window.location.href = '/dashboard';
        // After reload, tab will be set by default
      } else {
        setActiveTab(tabId);
      }
    } else {
      setActiveTab(tabId);
    }
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
        onClick={onClose}
      />
      
      {/* Drawer */}
        <div className="fixed inset-y-0 left-0 w-44 bg-gradient-to-br from-gray-950 to-gray-900/95 z-50 transform transition-transform duration-200 ease-in-out md:hidden shadow-lg border-r border-gray-800/60 rounded-tr-xl rounded-br-xl text-[13px] sm:text-[14px] flex flex-col"
        style={{ transform: isOpen ? 'translateX(0)' : 'translateX(-100%)' }}>
        
        {/* Drawer Header - always visible */}
        <div className="flex items-center justify-between p-3 border-b border-gray-800 bg-gray-950 sticky top-0 z-50">
          <div className="flex items-center space-x-2">
              <div className="w-7 h-7 bg-gradient-to-br from-blue-500 to-purple-600 rounded-md flex items-center justify-center shadow-sm">
                <img src={logo} alt="Dolphin Logo" className="w-5 h-5 object-contain" />
              </div>
              <div>
                <h2 className="text-[15px] font-bold text-white tracking-tight">DOLPHIN</h2>
                <p className="text-[9px] text-gray-400 leading-tight">Mining Platform</p>
              </div>
          </div>
          <button 
            onClick={onClose}
            className="p-1 hover:bg-gray-800 rounded-lg transition-colors"
          >
            <FaTimes size={17} className="text-gray-400" />
          </button>
        </div>
        

  

        {/* Navigation */}
        <div className="flex-1 overflow-y-auto pt-2 pb-4 text-[13px] text-gray-300">
          {/* Main Navigation */}
          <div className="px-4 mb-6">
            <h3 className="text-[11px] font-bold text-gray-200 uppercase tracking-wider mb-3">MAIN</h3>
            <div className="space-y-1 text-[13px]">
              {mainNavItems.map(item => (
                <button
                  key={item.id}
                  className={`w-full flex items-center space-x-2 px-2.5 py-2 rounded-lg transition-all text-[13px] ${activeTab === item.id ? 'bg-blue-500/20 border-l-4 border-blue-500' : 'hover:bg-gray-800/60'}`}
                  onClick={() => handleNavigation(item.id)}
                >
                  <span className={`${activeTab === item.id ? 'text-blue-300' : 'text-gray-300'} text-[16px]`}>
                    {item.icon}
                  </span>
                  <span className={`font-semibold ${activeTab === item.id ? 'text-white' : 'text-gray-200'} truncate text-[13px]`}>
                    {item.label}
                  </span>
                  {activeTab === item.id && (
                    <FaChevronRight size={12} className="text-blue-400 ml-auto" />
                  )}
                </button>
              ))}
            </div>
          </div>

          {/* Admin Section */}
          {isAdmin && (
            <div className="px-3 mb-4">
              <h3 className="text-[10px] font-semibold text-gray-300 uppercase tracking-wider mb-2">ADMIN</h3>
              <div className="space-y-0.5 text-[13px]">
                {[
                  { id: 'admin-overview', icon: <HiOutlineViewGrid size={16} />, label: 'Admin Overview' },
                  { id: 'admin-mining-tokenomics', icon: <FaHammer size={14} />, label: 'Mining & Tokenomics' },
                  { id: 'admin-treasury-security', icon: <FaCoins size={14} />, label: 'Treasury & Security' },
                  { id: 'admin-analytics', icon: <FaChartPie size={14} />, label: 'Admin Analytics' },
                  { id: 'admin-user-activity', icon: <FaUser size={14} />, label: 'User Activity' },
                ].map(item => (
                  <button
                    key={item.id}
                    className={`w-full flex items-center space-x-2 px-2 py-2 rounded-md transition-all text-[13px] ${activeTab === item.id ? 'bg-purple-500/10 border-l-4 border-purple-500' : 'hover:bg-gray-800/40'}`}
                    onClick={() => handleNavigation(item.id)}
                  >
                    <span className={`${activeTab === item.id ? 'text-purple-300' : 'text-gray-300'} text-[15px]`}>
                      {item.icon}
                    </span>
                    <span className={`font-medium ${activeTab === item.id ? 'text-white' : 'text-gray-200'} truncate text-[13px]`}>
                      {item.label}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Support Section */}
          <div className="px-3 mb-2">
            <h3 className="text-[10px] font-semibold text-gray-300 uppercase tracking-wider mb-2">SUPPORT</h3>
            <div className="space-y-0.5 text-[13px]">
              <button 
                className="w-full flex items-center space-x-2 px-2 py-2 rounded-md hover:bg-gray-800/40 transition-all text-[13px]"
                onClick={() => window.open('mailto:support@example.com', '_blank')}
              >
                <FaHeadset size={15} className="text-gray-400" />
                <span className="font-medium text-gray-200">Contact Support</span>
              </button>
              <button 
                className="w-full flex items-center space-x-2 px-2 py-2 rounded-md hover:bg-gray-800/40 transition-all text-[13px]"
                onClick={() => window.open('https://docs.example.com', '_blank')}
              >
                <HiOutlineDocumentText size={15} className="text-gray-400" />
                <span className="font-medium text-gray-200">Documentation</span>
              </button>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-3 border-t border-gray-800 text-[12px] text-gray-300">
          <button 
            className="w-full flex items-center justify-center space-x-2 px-3 py-2 bg-gradient-to-r from-red-500/20 to-red-600/20 border border-red-500/30 rounded-lg hover:bg-red-500/30 transition-all text-[13px]"
            onClick={disconnectWallet}
          >
            <FaSignOutAlt size={15} className="text-red-400" />
            <span className="font-medium text-red-200">Disconnect Wallet</span>
          </button>
          <p className="text-[11px] text-gray-400 text-center mt-3">
            Connected to Polygon Network
          </p>
        </div>
      </div>
    </>
  );
};

export default MobileDrawer;